// ============================================================================
// ACTION TODAY WIDGET — Phase 8.D
// ============================================================================
// Cases assigned to the officer that need attention:
//   • COOLING_OFF_ELAPSED — a NOTICE state has been pending > 14 days.
//   • NO_PROGRESS         — no workflow advance in > 7 days.
// Held cases are filtered out at the server.

import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import { useActionToday } from 'hooks/api/useRecoveryDashboard';
import { openLitigationCase } from 'components/modules/litigation-module/openLitigationCase';
import type { ActionReasonCode } from 'api/types/recoveryDashboard.types';

interface Props { refreshKey?: number; }

const reasonChipClass = (code: ActionReasonCode): string => {
  switch (code) {
    case 'COOLING_OFF_ELAPSED': return 'dashboard-reason-chip cooling-off';
    case 'NO_PROGRESS':         return 'dashboard-reason-chip no-progress';
    default:                    return 'dashboard-reason-chip';
  }
};

const ActionTodayWidget: React.FC<Props> = ({ refreshKey }) => {
  const { data, loading } = useActionToday(10, refreshKey);

  return (
    <div className="dashboard-widget">
      <div className="dashboard-widget-header">
        <h3 className="dashboard-widget-title">
          <IconSystem.alert size={18} />
          Action Today
        </h3>
        <span className="dashboard-kpi-chip">{data.length}</span>
      </div>
      <div className="dashboard-widget-subtitle">
        Cases stuck or with elapsed cooling-off &mdash; not on hold
      </div>
      <div className="dashboard-widget-body">
        {loading ? (
          <div className="dashboard-widget-loading">Loading...</div>
        ) : data.length === 0 ? (
          <div className="dashboard-widget-empty">Nothing needs your attention.</div>
        ) : (
          data.map(item => (
            <div key={item.caseId} className="dashboard-list-row" onClick={() => openLitigationCase(item.caseId)} style={{ cursor: 'pointer' }}>
              <div className="dashboard-list-row-main">
                <span className="dashboard-list-row-title">
                  {item.borrowerName || '—'} <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>· {item.caseCode}</span>
                </span>
                <span className="dashboard-list-row-meta">
                  {item.currentStateDisplayName || item.currentStateCode} · {item.daysInState}d in state
                </span>
              </div>
              <span className={reasonChipClass(item.reasonCode)}>{item.reason}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ActionTodayWidget;
